import { useState } from "react";
import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Chip,
  Button,
  Box
} from "@mui/material";
import EmailModal from "../components/modal/EmailModal";


export const FrontPageTrailerCard = ({ trailerData }) => {
    const [trailer] = useState(trailerData);
    const [modalOpen, setModalOpen] = useState(false);

    const handleContactClick = () => {
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    return (
        <Card sx={{
            maxWidth: 345,
            borderRadius: 3,
            boxShadow: 3,
            display: "flex",
            flexDirection: "column",
            height: 875,
        }}>
            <CardMedia
            component="img"
            height="350"
            image={trailer.image}
            alt={trailer.title}
            sx={{
                objectFit: "contain"
            }}
            />

            {/* There should always be at least 1 badge */}
            <CardHeader
                title={trailer.title}
                action={
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {trailer.badge && (
                            <Chip
                                label={trailer.badge}
                                color="primary"
                                size="small"
                                sx={{
                                    fontWeight: "bold",
                                    backgroundColor: {"Special Offer!": "red", "Best Seller": "blue"}[trailer.badge] || "gray",
                                }}
                            />
                        )}
                        {/* Jank. Refactor/fix if it gets too weird. */}
                        {trailer.badge2 && (
                            <Chip
                                label={trailer.badge2}
                                color="secondary"
                                size="small"
                                sx={{
                                    fontWeight: "bold",
                                    backgroundColor: "blue",
                                    color: "white"
                                }}
                            />
                        )}
                    </Box>
                }
            />
            <CardContent sx={{
                padding: '0 1em',
                flexGrow: 1,
            }}>
            <Typography variant="body1" color="text.primary">
                {trailer.description}
            </Typography>
            </CardContent>
            <CardContent>
            <Typography
                variant="h6"
                color="text.primary"
                sx={{
                    fontWeight: "bold"
                }}
            >
                Key Specs:
            </Typography>
            {trailer.specs.map((spec, index) => (
                <Typography key={index} variant="body2" color="text.secondary" gutterBottom>
                • {spec}
                </Typography>
            ))}
            <Typography
                variant="h5"
                color="text.primary"
                align="center"
                sx={{ marginTop: "0.5em", fontWeight: "bold" }}
            >
                Starting at {trailer.price}!!!
            </Typography>
            </CardContent>
            <CardActions>
            <Button variant="contained" color="primary" onClick={handleContactClick} fullWidth>
                Contact Us Today!
            </Button>
            </CardActions>

            <EmailModal
                open={modalOpen}
                handleClose={handleModalClose}
                customMessage={trailer.contactHint}
            />
        </Card>
    );
}

export default FrontPageTrailerCard;